type TokenValue = string | { readonly [key: string]: TokenValue };

const flatten = (value: TokenValue, prefix: string, out: Record<string, string>): Record<string, string> => {
  if (typeof value === 'string') {
    out[prefix] = value;
    return out;
  }
  for (const [key, child] of Object.entries(value)) flatten(child, `${prefix}-${key}`, out);
  return out;
};

export const tokensToCssVariables = (
  tokens: Readonly<Record<string, TokenValue>>,
  selector = ':root',
): string => {
  const variables = Object.entries(flatten(tokens, '-', {}))
    .map(([name, value]) => `${name}: ${value};`)
    .join(' ');
  return `${selector} { ${variables} }`;
};

export const cssVar = (path: string): string => `var(--${path.replaceAll('.', '-')})`;
